export function CTA() {
  return (
    <section className="relative py-32 bg-cover bg-center overflow-hidden" style={{
      backgroundImage: 'linear-gradient(180deg, rgba(0,0,0,0.4), rgba(0,0,0,0.3)), url("/images/cta.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      minHeight: '500px',
      display: 'flex',
      alignItems: 'center',
    }}>
      <div className="max-w-4xl mx-auto text-center px-4 relative z-10 w-full">
        <h2 className="text-[40px] text-white mb-6 leading-tight">
          GET STARTED
        </h2>
        <p className="text-white text-base md:text-lg mb-10 leading-relaxed font-light max-w-2xl mx-auto">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor. Incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.
        </p>

        <a 
          href="#" 
          className="inline-block bg-white text-gray-800 px-8 py-3 rounded-full font-semibold text-base hover:bg-gray-100 transition"
        >
          CREATE FREE ACCOUNT
        </a>
      </div>
    </section>
  )
}
